<template>
  <div class="dashboard-index" style="height: 100%">
    <div class="flex-row flex__between">
      <div
        class="
          header-title
          font-size__large
          flex-row flex__left
          color__black
          margin-bottom-10
        "
        v-if="!!user"
      ></div>
      <user-header />
    </div>
    <div class="style-fullWidth flex-row flex-right__top" style="height: 100%">
      <!--  main-->
      <div class="cards-area main-content-dashboard" style="height: 100%">
        <vue-perfect-scrollbar class="scroll-area">
          <el-row :gutter="24" style="margin-right: 3px">
            <div class="filter-dashboard">
              <div style="margin-top: 5px">
                <div
                  style="
                    margin-left: 12px;
                    height: 20px;
                    display: flex;
                    align-items: end;
                    font-weight: 700;
                    font-size: 18px;
                    color: #303133;
                  "
                >
                  Xin chào,
                  {{ `${user && user.fullName}` }}!
                </div>
                <div
                  style="
                    font-size: 13px;
                    margin-left: 12px;
                    color: rgb(136, 152, 170);
                    padding-top: 5px;
                  "
                >
                  {{
                    userDeptRole
                      ? userDeptRole.positionName + " " + userDeptRole.deptName
                      : ""
                  }}
                </div>
              </div>
              <div style="display: flex">
                <div style="width: 185px">
                  <el-date-picker
                    v-model="docDateRange"
                    type="daterange"
                    format="dd/MM/yyyy"
                    class="
                      style-fullWidth
                      input-border__bottom input-border__radius__0
                      bg__transparent
                    "
                    :picker-options="dateQuickFilterOption"
                    range-separator="_"
                    start-placeholder="_"
                    end-placeholder="_"
                    align="right"
                    :clearable="false"
                    @change="filterByDocDateRange"
                  >
                  </el-date-picker>
                </div>
                <!-- <div
                  style="display: flex; align-items: center; height: 40px"
                  title="Cấu hình dashboard"
                  @click="isOpenSettingDialog = true"
                >
                  <i class="fal fa-cog"></i>
                </div> -->
              </div>
            </div>
          </el-row>
          <el-row :gutter="24" style="margin-top: 15px">
            <el-col :span="24">
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  flex-wrap: wrap;
                "
              >
                <div class="block-report">
                  <div
                    style="
                      display: flex;
                      justify-content: space-between;
                      margin-bottom: 5px;
                    "
                  >
                    <div class="my-element" data-link="https://www.google.com">
                      <h3 style="color: #8898aa; margin-bottom: 2px">
                        VĂN BẢN ĐẾN
                      </h3>
                      <div
                        style="
                          color: #32325d;
                          font-weight: 600;
                          font-size: 1.25rem;
                        "
                      >
                        {{ dashboards.countOfIncomingDoc || 0 }}
                        <label style="color: #2dce89; font-size: 14px"
                          >({{
                            dashboards.countOfUnreadIncomingDoc || 0
                          }}
                          mới)</label
                        >
                      </div>
                    </div>
                    <div>
                      <div class="icon bg-gradient-red">
                        <i
                          style="color: #fff"
                          class="far fa-inbox-in fa-fw"
                        ></i>
                      </div>
                    </div>
                  </div>
                  <el-tooltip content="Xem thêm" placement="bottom">
                    <div
                      @click="viewListIncomingDocProcessing()"
                      style="
                        align-items: center;
                        display: flex;
                        justify-content: space-between;
                        border-top: solid 1px #e5e5e5;
                        height: 30px;
                        margin-top: 10px;
                        cursor: pointer;
                      "
                    >
                      <div>Xem chi tiết</div>
                      <div class="">
                        <i
                          style="font-size: 16px"
                          class="far fa-arrow-to-right"
                        ></i>
                      </div>
                    </div>
                  </el-tooltip>
                </div>
                <div class="block-report">
                  <div
                    style="
                      display: flex;
                      justify-content: space-between;
                      margin-bottom: 5px;
                    "
                  >
                    <div>
                      <h3 style="color: #8898aa; margin-bottom: 2px">
                        VĂN BẢN ĐI
                      </h3>
                      <div
                        style="
                          color: #32325d;
                          font-weight: 600;
                          font-size: 1.25rem;
                        "
                      >
                        {{ dashboards.countOfOutGoingDoc || 0 }}
                        <label style="color: #2dce89; font-size: 14px"
                          >({{
                            dashboards.countOfUnreadOutGoingDoc || 0
                          }}
                          mới)</label
                        >
                      </div>
                    </div>
                    <div>
                      <div class="icon bg-gradient-orange">
                        <i
                          style="color: #fff"
                          class="far fa-inbox-out fa-fw"
                        ></i>
                      </div>
                    </div>
                  </div>
                  <el-tooltip content="Xem thêm" placement="bottom">
                    <div
                      @click="viewListOutgoingDocProcessing()"
                      style="
                        align-items: center;
                        display: flex;
                        justify-content: space-between;
                        border-top: solid 1px #e5e5e5;
                        height: 30px;
                        margin-top: 10px;
                        cursor: pointer;
                      "
                    >
                      <div>Xem chi tiết</div>
                      <div class="">
                        <i
                          style="font-size: 16px"
                          class="far fa-arrow-to-right"
                        ></i>
                      </div>
                    </div>
                  </el-tooltip>
                </div>
                <div class="block-report">
                  <div
                    style="
                      display: flex;
                      justify-content: space-between;
                      margin-bottom: 5px;
                    "
                  >
                    <div>
                      <h3 style="color: #8898aa; margin-bottom: 2px">
                        CÔNG VIỆC TÔI GIAO
                      </h3>
                      <div>
                        <span
                          title="Xem công việc đang thực hiện"
                          style="cursor: pointer"
                          @click="viewListCVDaGiao('DANG_THUC_HIEN')"
                        >
                          <span
                            style="
                              color: #32325d;
                              font-weight: 600;
                              font-size: 1.25rem;
                            "
                            >{{
                              dashboards.countOfTaskAssignDangXuLy || 0
                            }}</span
                          >
                        </span>
                        <label
                          title="Xem công việc chờ duyệt"
                          @click="viewListCVDaGiao('CHO_PHE_DUYET_DK')"
                          style="
                            color: #2dce89;
                            font-size: 14px;
                            cursor: pointer;
                          "
                          >({{ dashboards.countOfTaskAssignChoPheDuyet }} chờ
                          duyệt)</label
                        >
                      </div>
                    </div>
                    <div>
                      <div class="icon bg-gradient-green">
                        <i style="color: #fff" class="fal fa-briefcase"></i>
                      </div>
                    </div>
                  </div>
                  <el-tooltip
                    content="Xem thêm tất cả công việc"
                    placement="bottom"
                  >
                    <div
                      @click="viewListCVDaGiao()"
                      style="
                        align-items: center;
                        display: flex;
                        justify-content: space-between;
                        border-top: solid 1px #e5e5e5;
                        height: 30px;
                        margin-top: 10px;
                        cursor: pointer;
                      "
                    >
                      <div>Xem chi tiết</div>
                      <div class="">
                        <i
                          style="font-size: 16px"
                          class="far fa-arrow-to-right"
                        ></i>
                      </div>
                    </div>
                  </el-tooltip>
                </div>
                <div class="block-report">
                  <div
                    style="
                      display: flex;
                      justify-content: space-between;
                      margin-bottom: 5px;
                    "
                  >
                    <div>
                      <h3 style="color: #8898aa; margin-bottom: 2px">
                        CÔNG VIỆC ĐƯỢC GIAO
                      </h3>
                      <div>
                        <span
                          title="Xem công việc đang thực hiện"
                          style="cursor: pointer"
                          @click="viewListCVDuocGiao('DANG_THUC_HIEN')"
                        >
                          <span
                            style="
                              color: #32325d;
                              font-weight: 600;
                              font-size: 1.25rem;
                            "
                            >{{
                              dashboards.countOfTaskReciveDangXuLy || 0
                            }}</span
                          >
                        </span>
                        <label
                          @click="viewListCVDuocGiao('CHO_PHE_DUYET_DK')"
                          style="
                            color: #2dce89;
                            font-size: 14px;
                            cursor: pointer;
                          "
                          >({{ dashboards.countOfTaskReciveChoPheDuyet }} chờ
                          duyệt)</label
                        >
                      </div>
                    </div>
                    <div>
                      <div class="icon bg-gradient-info">
                        <i style="color: #fff" class="fal fa-briefcase"></i>
                      </div>
                    </div>
                  </div>
                  <el-tooltip content="Xem thêm" placement="bottom">
                    <div
                      @click="viewListCVDuocGiao()"
                      style="
                        align-items: center;
                        display: flex;
                        justify-content: space-between;
                        border-top: solid 1px #e5e5e5;
                        height: 30px;
                        margin-top: 10px;
                        cursor: pointer;
                      "
                    >
                      <div>Xem chi tiết</div>
                      <div class="">
                        <i
                          style="font-size: 16px"
                          class="far fa-arrow-to-right"
                        ></i>
                      </div>
                    </div>
                  </el-tooltip>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="24" style="margin-top: 15px">
            <el-col
              v-if="isVisibleIncommingDoc && incomingDocsCount"
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="12"
            >
              <div class="card-area">
                <doc-in-dashboard-card-v2
                  :type="DASHBBOARD_TYPE.VBDEN_CHO_XU_LY"
                  :userDeptRoles="userDeptRoles"
                  :cardTitle="'Văn bản đến chờ xử lý'"
                  :docs="incomingDocs"
                  :docsCount="incomingDocsCount"
                  :getItemKeyFn="(item) => item.id"
                  @viewDetail="viewDetailIncomingDoc"
                  @viewMore="viewListIncomingDocProcessing"
                >
                </doc-in-dashboard-card-v2>
              </div>
            </el-col>
            <el-col
              v-if="isVisibleOutgoingDoc && outgoingDocsCount"
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="12"
            >
              <div class="card-area">
                <doc-out-dashboard-card-v2
                  :type="DASHBBOARD_TYPE.VBDI_CHO_XU_LY"
                  :cardTitle="'Văn bản đi chờ xử lý'"
                  :docs="outgoingDocs"
                  :docsCount="outgoingDocsCount"
                  :getItemKeyFn="(item) => item.id"
                  @viewDetail="viewDetailOutgoingDoc"
                  @viewMore="viewListOutgoingDocProcessing"
                >
                </doc-out-dashboard-card-v2>
              </div>
            </el-col>
            <el-col
              v-if="isVisibleChoBanHanh && vanBanChoBanHanhCount"
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="12"
            >
              <div class="card-area">
                <doc-out-dashboard-card-v2
                  :type="DASHBBOARD_TYPE.VB_CHO_BAN_HANH"
                  :cardTitle="'Văn bản chờ ban hành'"
                  :docs="vanBanChoBanHanh"
                  :docsCount="vanBanChoBanHanhCount"
                  :getItemKeyFn="(item) => item.id"
                  @viewDetail="viewDetailChoBanHanh"
                  @viewMore="viewMoreChoBanHanh"
                >
                </doc-out-dashboard-card-v2>
              </div>
            </el-col>
            <el-col
              v-if="isVisibleChoTiepNhan && vanBanChoTiepNhanCount"
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="12"
            >
              <div class="card-area">
                <doc-in-dashboard-card-v2
                  :type="DASHBBOARD_TYPE.VB_CHO_TIEP_NHAN"
                  :cardTitle="'Văn bản chờ tiếp nhận'"
                  :docs="vanBanChoTiepNhan"
                  :docsCount="vanBanChoTiepNhanCount"
                  :getItemKeyFn="(item) => item.id"
                  @viewDetail="viewDetailChoTiepNhan"
                  @viewMore="viewMoreChoTiepNhan"
                >
                </doc-in-dashboard-card-v2>
              </div>
            </el-col>
            <el-col
              v-if="dataCVDuocGiao.length"
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="12"
            >
              <div class="card-area">
                <job-dashboard-card
                  :type="DASHBBOARD_TYPE.CV_DUOC_GIAO"
                  :userDeptRoles="userDeptRoles"
                  :cardTitle="'Công việc được giao'"
                  :jobs="returnListJob(dataCVDuocGiao)"
                  :getItemKeyFn="(item) => item.id"
                  @viewDetail="viewDetailCVDuocGiao"
                  @viewMore="viewListCVDaGiao"
                >
                </job-dashboard-card>
              </div>
            </el-col>
            <el-col
              v-if="dataCVDaGiao.length"
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="12"
            >
              <div class="card-area">
                <job-dashboard-card
                  :type="DASHBBOARD_TYPE.CV_TOI_GIAO"
                  :userDeptRoles="userDeptRoles"
                  :cardTitle="'Công việc tôi giao'"
                  :jobs="returnListJob(dataCVDaGiao)"
                  :getItemKeyFn="(item) => item.id"
                  @viewDetail="viewDetailCVDaGiao"
                  @viewMore="viewListCVDaGiao"
                >
                </job-dashboard-card>
              </div>
            </el-col>
            <el-col
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="12"
              v-if="checkDisplayDashBoard(incomingChart)"
            >
              <bar-chart
                :key="incomingChart"
                :type="DASHBBOARD_TYPE.VBDEN_CHO_XU_LY"
                title="Văn bản đến"
                :dataChart="incomingChart"
                @viewMore="viewListIncomingDocProcessing"
              />
            </el-col>
            <el-col
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="12"
              v-if="checkDisplayDashBoard(outgoingChart)"
            >
              <bar-chart
                :key="outgoingChart"
                :type="DASHBBOARD_TYPE.VBDI_CHO_XU_LY"
                title="Văn bản đi"
                :dataChart="outgoingChart"
                @viewMore="viewListOutgoingDocProcessing"
              />
            </el-col>
            <el-col
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="12"
              v-if="checkDisplayDashBoard(CVDaGiaoChart)"
            >
              <pie-chart
                :key="CVDaGiaoChart"
                :type="DASHBBOARD_TYPE.CV_TOI_GIAO"
                title="Công việc tôi giao"
                :dataChart="CVDaGiaoChart"
                @viewMore="viewListCVDaGiao"
              />
            </el-col>
            <el-col
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="12"
              v-if="checkDisplayDashBoard(CVDuocGiaoChart)"
            >
              <pie-chart
                :key="CVDuocGiaoChart"
                :type="DASHBBOARD_TYPE.CV_DUOC_GIAO"
                title="Công việc được giao"
                :dataChart="CVDuocGiaoChart"
                @viewMore="viewListCVDuocGiao"
              />
            </el-col>
          </el-row>
        </vue-perfect-scrollbar>
      </div>
      <!--  main:end-->
      <!--  right-->
      <div class="notification-area">
        <notifications-card-v2
          :cardTitle="'Thông báo'"
          :notifis="notifications"
          :notifysCount="notificationsCount"
          :unreadNotifysCount="notificationsUnreadCount"
        >
        </notifications-card-v2>
      </div>
      <!--  right:end-->
    </div>
  </div>
</template>
<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import headerTemplate from "../../components/header/main-header.vue";
import dashBoardService from "../../services/dashBoardService";
import h from "../../services/h";
import IncomingDocsCard from "./IncomingDocsCard";
import OutgoingDocsCard from "./OutgoingDocsCard";
import CongViecCard from "./CongViecCard";
import NotifyCard from "./NotifyCard";
import ChoBanHanhCard from "./ChoBanHanhCard";
import ChoTiepNhanCard from "./ChoTiepNhanCard";
import constants from "../../constants";
import { EventBus } from "../../event-bus";
import menuConfigService from "../../services/menuConfigService";
import NotificationsCardV2 from "./notifications-card-v2";
import DocInDashboardCardV2 from "./doc-in-dashboard-card-v2";
import DocOutDashboardCardV2 from "./doc-out-dashboard-card-v2";
import UserHeader from "../../components/header/user-header";
import JobDashboardCard from "./job-dashboard-card.vue";
import utils from "../../services/utils";
import dateUtils from "../../dateUtils";
import PieChart from "../home/components/PieChart.vue";
import BarChart from "../home/components/BarChart.vue";

export default {
  name: "dashboard",
  components: {
    UserHeader,
    DocOutDashboardCardV2,
    DocInDashboardCardV2,
    NotificationsCardV2,
    IncomingDocsCard,
    OutgoingDocsCard,
    JobDashboardCard,
    CongViecCard,
    NotifyCard,
    ChoBanHanhCard,
    ChoTiepNhanCard,
    listTemplate: () => import("../common/list"),
    VuePerfectScrollbar,
    headerTemplate,
    PieChart,
    BarChart,
  },
  data() {
    return {
      DASHBBOARD_TYPE: constants.DASHBBOARD_TYPE,
      notifications: [],
      notificationsCount: null,
      notificationsUnreadCount: null,

      dateQuickFilterOption: utils.getDefaultDateQuickFilterOption(),
      docDateRange: [null, null],

      incomingChart: null,
      outgoingChart: null,
      CVDaGiaoChart: null,
      CVDuocGiaoChart: null,

      incomingDocs: [],
      incomingDocsCount: null,
      unreadIncomingDocsCount: null,

      shareLibDocs: [],

      vanBanChoBanHanh: [],
      vanBanChoBanHanhCount: null,

      vanBanChoTiepNhan: [],
      vanBanChoTiepNhanCount: null,

      outgoingDocs: [],
      outgoingDocsCount: null,
      unreadOutgoingDocsCount: null,

      listDashBoard: [],
      dashboards: [],
      menuConfigs: [],
      checkedMenuCodes: [],
      isVisibleIncommingDoc: false,
      isVisibleOutgoingDoc: false,
      isVisibleCongViec: false,
      isVisibleChoBanHanh: false,
      isVisibleChoTiepNhan: false,
      userDeptRoleIdForIncommingDoc: null,
      userDeptRoleIdForOutgoingDoc: null,
      userDeptRoleIdForBanHanhOutgoingDoc: null,
      userDeptRoleIdForCongViec: null,
      userDeptRoleIdForHanhChinh: null,
      userDeptRoleIdForChoBanHanh: null,
      userDeptRoleIdForChoTiepNhan: null,

      // Dữ liệu công việc
      dataCVDaGiao: [],
      dataCVDuocGiao: [],
    };
  },

  computed: {
    userDeptRole() {
      return this.$store.getters.userDeptRole;
    },
    userDeptRoleView() {
      return this.$store.getters.userDeptRoleView;
    },
    userDeptRoles() {
      return this.$store.getters.userDeptRoles;
    },
    userDeptRolesId() {
      return this.$store.getters.userDeptRoleId;
    },
    user() {
      return this.$store.getters.user;
    },
  },

  watch: {
    userDeptRole() {
      this.loadData();
      this.setVisible().then((res) => {
        if (this.isVisibleIncommingDoc) {
          this.loadIncomingDocsDashBoard();
          this.loadIncomingChartDashBoard();
        }
        if (this.isVisibleOutgoingDoc) {
          this.loadOutgoingDocsDashBoard();
          this.loadOutgoingChartDashBoard();
        }
        if (this.isVisibleChoBanHanh) {
          this.loadVanBanChoBanHanh();
        }
        if (this.isVisibleChoTiepNhan) {
          this.loadVanBanChoTiepNhan();
        }
        if (this.isVisibleCongViec) {
          this.loadDataCVDaGiao();
          this.loadCVDaGiaoChartDashBoard();
          this.loadCVDuocGiaoChartDashBoard();
          this.loadDataCVDuocGiao();
        }
      });
    },
  },

  created() {
    this.initDocDateRange();
    this.loadNotificationsDashBoard();
    this.loadData();
    this.setVisible().then((res) => {
      if (this.isVisibleIncommingDoc) {
        this.loadIncomingDocsDashBoard();
        this.loadIncomingChartDashBoard();
      }
      if (this.isVisibleOutgoingDoc) {
        this.loadOutgoingDocsDashBoard();
        this.loadOutgoingChartDashBoard();
      }
      if (this.isVisibleChoBanHanh) {
        this.loadVanBanChoBanHanh();
      }
      if (this.isVisibleChoTiepNhan) {
        this.loadVanBanChoTiepNhan();
      }
      if (this.isVisibleCongViec) {
        this.loadDataCVDaGiao();
        this.loadCVDaGiaoChartDashBoard();
        this.loadCVDuocGiaoChartDashBoard();
        this.loadDataCVDuocGiao();
      }
    });
  },

  methods: {
    checkDisplayDashBoard(value) {
      let check = value && value.reduce((a, b) => a + b, 0);
      return check;
    },
    initDocDateRange() {
      this.docDateRange = dateUtils.getDatesByQuickFilter(
        constants.DATE_QUICK_FILTER.CODE.NAM_NAY
      );
    },
    loadData() {
      return dashBoardService
        .getData({
          fromDocDate: this.docDateRange[0]
            ? this.docDateRange[0].getTime()
            : undefined,
          toDocDate: this.docDateRange[1]
            ? this.docDateRange[1].getTime()
            : undefined,
        })
        .then((response) => {
          this.dashboards = response.data;
          // return this.setVisible();
        });
    },

    loadDataCVDaGiao() {
      dashBoardService
        .getDashBoardCongViecDagiao({
          page: 0,
          // size: 10,
          // sort: "docDate,desc",
          fromStartDate: this.docDateRange[0]
            ? this.docDateRange[0].getTime()
            : undefined,
          toStartDate: this.docDateRange[1]
            ? this.docDateRange[1].getTime()
            : undefined,
        })
        .then((res) => {
          this.dataCVDaGiao = res.data.tasks || [];
        });
    },

    loadDataCVDuocGiao() {
      dashBoardService
        .getDashBoardCongViecDuocGiao({
          page: 0,
          // size: 10,
          // sort: "docDate,desc",
          fromStartDate: this.docDateRange[0]
            ? this.docDateRange[0].getTime()
            : undefined,
          toStartDate: this.docDateRange[1]
            ? this.docDateRange[1].getTime()
            : undefined,
        })
        .then((res) => {
          this.dataCVDuocGiao = res.data.tasks || [];
        });
    },

    viewMorelOutgoingDoc() {
      h.each(this.userDeptRoles, (userDeptRole) => {
        if (userDeptRole.roleCode == constants.ROLE.CODE.CHUYEN_VIEN) {
          this.userDeptRoleIdForOutgoingDoc = userDeptRole.id;
        }
      });
      this.$store.commit(
        "changeUserDeptRole",
        this.userDeptRoleIdForOutgoingDoc
      );
      EventBus.$emit(constants.EVENT_BUS.CHANGE_USER_DEPT_ROLE, {
        userDeptRoleId: this.userDeptRoleIdForOutgoingDoc,
      });
      this.$router.push({
        name: "vbDuThaoNew",
        params: { userDeptRoleId: this.userDeptRoleIdForOutgoingDoc },
      });
    },

    viewMoreIncomingDoc() {
      h.each(this.userDeptRoles, (userDeptRole) => {
        if (userDeptRole.roleCode == constants.ROLE.CODE.CHUYEN_VIEN) {
          this.userDeptRoleIdForIncommingDoc = userDeptRole.id;
        }
      });
      this.$store.commit(
        "changeUserDeptRole",
        this.userDeptRoleIdForIncommingDoc
      );
      EventBus.$emit(constants.EVENT_BUS.CHANGE_USER_DEPT_ROLE, {
        userDeptRoleId: this.userDeptRoleIdForIncommingDoc,
      });
      this.$router.push({
        name: "vbDenChoXuLy",
        params: {
          userDeptRoleId: this.userDeptRoleIdForIncommingDoc,
          dateRange: constants.DATE_QUICK_FILTER.CODE.NAM_NAY,
        },
      });
    },

    viewDetailIncomingDoc(event) {
      let item = event.doc;
      this.$router.push({
        name: "vbDenChoXuLyDetail",
        params: {
          id: item.id,
        },
        query: {
          fromSendTime: this.docDateRange[0]
            ? this.docDateRange[0].getTime()
            : undefined,
          toSendTime: this.docDateRange[1]
            ? this.docDateRange[1].getTime()
            : undefined,
          vbDocProcessId:
            item && item.vbDocUserVbDocProcessId
              ? item.vbDocUserVbDocProcessId
              : undefined,
        },
      });
    },

    viewDetailOutgoingDoc(event) {
      let item = event.doc;
      if (
        item.status == constants.OUTGOING_DOC_STATUS.TAOMOI ||
        (item.status == constants.OUTGOING_DOC_STATUS.TU_CHOI &&
          item.creatorId == this.userId) ||
        (item.status == constants.OUTGOING_DOC_STATUS.TU_CHOI_BAN_HANH &&
          item.creatorId == this.userId)
      ) {
        this.$router.push({
          name: "vbDuThaoNewEdit",
          params: {
            id: item.id,
            fromProcessTime: this.docDateRange[0]
              ? this.docDateRange[0].getTime()
              : undefined,
            toProcessTime: this.docDateRange[1]
              ? this.docDateRange[1].getTime()
              : undefined,
          },
        });
      } else {
        this.$router.push({
          name: "vbDuThaoNewDetail",
          params: {
            id: item.id,
          },
          query: {
            fromProcessTime: this.docDateRange[0]
              ? this.docDateRange[0].getTime()
              : undefined,
            toProcessTime: this.docDateRange[1]
              ? this.docDateRange[1].getTime()
              : undefined,
            vbDocProcessId:
              item && item.vbDocUserVbDocProcessId
                ? item.vbDocUserVbDocProcessId
                : undefined,
          },
        });
      }
    },

    viewDetailChoBanHanh(event) {
      let item = event.doc;
      this.$router.replace({
        name: "vbChoBanHanhDetail",
        params: { id: item.id, userDeptRoleId: this.userDeptRolesId },
        query: this.$route.query,
      });
    },

    viewDetailChoTiepNhan(event) {
      let item = event.doc;
      this.$router.replace({
        name: "vbChoTiepNhanDetailEditable",
        params: { id: item.id },
        query: this.$route.query,
      });
    },

    viewMoreChoBanHanh() {
      this.$router.push({
        name: "vbChoBanHanh",
        params: {
          dateRange: this.docDateRange,
        },
      });
    },

    viewMoreChoTiepNhan() {
      this.$router.push({
        name: "vbChoTiepNhan",
        params: {
          dateRange: this.docDateRange,
        },
      });
    },

    loadIncomingDocsDashBoard() {
      dashBoardService
        .getIncomingDocsDashBoard({
          page: 0,
          // size: 10,
          sort: "docDate,desc",
          fromDocDate: this.docDateRange[0]
            ? this.docDateRange[0].getTime()
            : undefined,
          toDocDate: this.docDateRange[1]
            ? this.docDateRange[1].getTime()
            : undefined,
        })
        .then((response) => {
          let incomingDocsDashBoard = response.data;
          this.incomingDocs = incomingDocsDashBoard.docs;
          this.incomingDocsCount = incomingDocsDashBoard.docsCount;
          this.unreadIncomingDocsCount = incomingDocsDashBoard.unreadDocsCount;
        });
    },

    loadIncomingChartDashBoard() {
      dashBoardService
        .getIncomingChartDashBoard({
          fromDocDate: this.docDateRange[0]
            ? this.docDateRange[0].getTime()
            : undefined,
          toDocDate: this.docDateRange[1]
            ? this.docDateRange[1].getTime()
            : undefined,
        })
        .then((response) => {
          this.incomingChart = response.data.incomingDoc
            ? Object.values(response.data.incomingDoc)
            : null;
        });
    },

    loadOutgoingChartDashBoard() {
      dashBoardService
        .getOutgoingChartDashBoard({
          fromDocDate: this.docDateRange[0]
            ? this.docDateRange[0].getTime()
            : undefined,
          toDocDate: this.docDateRange[1]
            ? this.docDateRange[1].getTime()
            : undefined,
        })
        .then((response) => {
          this.outgoingChart = response.data.outgoingDoc
            ? Object.values(response.data.outgoingDoc)
            : null;
        });
    },

    loadCVDaGiaoChartDashBoard() {
      dashBoardService
        .getDashBoardChartCVDagiao({
          fromDocDate: this.docDateRange[0]
            ? this.docDateRange[0].getTime()
            : undefined,
          toDocDate: this.docDateRange[1]
            ? this.docDateRange[1].getTime()
            : undefined,
        })
        .then((response) => {
          this.CVDaGiaoChart = response.data.taskAssigner
            ? Object.values(response.data.taskAssigner)
            : null;
        });
    },

    loadCVDuocGiaoChartDashBoard() {
      dashBoardService
        .getDashBoardChartCVDuocGiao({
          fromDocDate: this.docDateRange[0]
            ? this.docDateRange[0].getTime()
            : undefined,
          toDocDate: this.docDateRange[1]
            ? this.docDateRange[1].getTime()
            : undefined,
        })
        .then((response) => {
          this.CVDuocGiaoChart = response.data.taskReceive
            ? Object.values(response.data.taskReceive)
            : null;
        });
    },

    loadVanBanChoBanHanh() {
      dashBoardService
        .getVanBanChoBanHanhDashBoard({
          page: 0,
          // size: 10,
          sort: "docDate,desc",
          fromDocDate: this.docDateRange[0]
            ? this.docDateRange[0].getTime()
            : undefined,
          toDocDate: this.docDateRange[1]
            ? this.docDateRange[1].getTime()
            : undefined,
        })
        .then((response) => {
          let vanBanChoBanHanhDashBoard = response.data;
          this.vanBanChoBanHanh = vanBanChoBanHanhDashBoard.docs;
          this.vanBanChoBanHanhCount = vanBanChoBanHanhDashBoard.docsCount;
        });
    },

    loadVanBanChoTiepNhan() {
      dashBoardService
        .getVanBanChoTiepNhanDashBoard({
          page: 0,
          // size: 10,
          sort: "docDate,desc",
          fromDocDate: this.docDateRange[0]
            ? this.docDateRange[0].getTime()
            : undefined,
          toDocDate: this.docDateRange[1]
            ? this.docDateRange[1].getTime()
            : undefined,
        })
        .then((response) => {
          let vanBanChoTiepNhanDashBoard = response.data;
          this.vanBanChoTiepNhan = vanBanChoTiepNhanDashBoard.docs;
          this.vanBanChoTiepNhanCount = vanBanChoTiepNhanDashBoard.docsCount;
        });
    },

    loadOutgoingDocsDashBoard() {
      dashBoardService
        .getOutgoingDocsDashBoard({
          page: 0,
          // size: 10,
          sort: "createTime,desc",
          fromDocDate: this.docDateRange[0]
            ? this.docDateRange[0].getTime()
            : undefined,
          toDocDate: this.docDateRange[1]
            ? this.docDateRange[1].getTime()
            : undefined,
        })
        .then((response) => {
          let outgoingDocsDashBoard = response.data;
          this.outgoingDocs = outgoingDocsDashBoard.docs;
          this.outgoingDocsCount = outgoingDocsDashBoard.docsCount;
          this.unreadOutgoingDocsCount = outgoingDocsDashBoard.unreadDocsCount;
        });
    },

    loadNotificationsDashBoard() {
      dashBoardService
        .getNotificationsDashBoard({
          page: 0,
          size: 50,
          sort: "createTime,desc",
        })
        .then((response) => {
          let notificationDashBoard = response.data;
          this.notifications = notificationDashBoard.notis;
          this.notificationsCount = notificationDashBoard.countNotis;
          this.notificationsUnreadCount =
            notificationDashBoard.countNotiUnreads;
        });
    },

    loadCheckedMenu(item) {
      return menuConfigService
        .findAllByUserDeptRoleId(
          item && item.userDeptRole && item.userDeptRole.id
        )
        .then((response) => {
          this.menuConfigs = response.data;
          this.checkedMenuCodes = h.collect(
            h.findAll(
              this.menuConfigs,
              (menuConfig) =>
                menuConfig.status == constants.MENU_CONFIG.STATUS.ACTIVE
            ),
            (menuConfig) => menuConfig.menuCode
          );
          h.each(this.checkedMenuCodes, (menuCode) => {
            switch (menuCode) {
              case constants.MENU_LIST.VB_DEN_CHOXULY:
                this.userDeptRoleIdForIncommingDoc = item.userDeptRole.id;
                this.isVisibleIncommingDoc = true;
                break;
              case constants.MENU_LIST.VB_DI_DUTHAO:
                this.userDeptRoleIdForOutgoingDoc = item.userDeptRole.id;
                this.isVisibleOutgoingDoc = true;
                break;
              case constants.MENU_LIST.VB_DI_DAPHATHANH:
                this.userDeptRoleIdForBanHanhOutgoingDoc = item.userDeptRole.id;
                this.isVisibleBanHanhOutgoingDoc = true;
                break;
              case constants.MENU_LIST.CONGVIEC:
                this.userDeptRoleIdForCongViec = item.userDeptRole.id;
                this.isVisibleCongViec = true;
                break;
              case constants.MENU_LIST.VB_DEN_CHOTIEPNHAN:
                this.userDeptRoleIdForChoTiepNhan = item.userDeptRole.id;
                this.isVisibleChoTiepNhan = true;
                break;
              case constants.MENU_LIST.VB_DI_CHOBANHANH:
                this.userDeptRoleIdForChoBanHanh = item.userDeptRole.id;
                this.isVisibleChoBanHanh = true;
                break;
            }
          });
        });
    },

    setVisible() {
      return this.loadCheckedMenu({
        userDeptRole: this.$store.getters.userDeptRole,
      });
    },

    returnListJob(dataJob) {
      let jobs = [];
      if (dataJob && dataJob.length) {
        jobs = jobs.concat(
          ...dataJob.map((x) => {
            return {
              ...x,
              quote: x.taskTitle,
              userDeptRoleView: this.userDeptRoleView,
            };
          })
        );
      }
      return jobs;
    },

    viewListIncomingDocProcessing(item) {
      this.$router.push({
        name: "vbDenChoXuLy",
        query: {
          fromSendTime: this.docDateRange[0]
            ? this.docDateRange[0].getTime()
            : undefined,
          toSendTime: this.docDateRange[1]
            ? this.docDateRange[1].getTime()
            : undefined,
        },
      });
    },

    viewListOutgoingDocProcessing(item) {
      this.$router.push({
        name: "vbDuThaoNew",
        query: {
          fromProcessTime: this.docDateRange[0]
            ? this.docDateRange[0].getTime()
            : undefined,
          toProcessTime: this.docDateRange[1]
            ? this.docDateRange[1].getTime()
            : undefined,
        },
      });
    },

    viewListCVDaGiao(status) {
      this.$router.push({
        name: "job-index-assigned",
        query: {
          delegateFilter: "all",
          taskStatuses: this.convertTaskStatus(status),
          taskStatusFilter: this.convertStatusFilter(status),
          viewType: "assigner",
          fromStartDate: this.docDateRange[0]
            ? this.docDateRange[0].getTime()
            : undefined,
          toStartDate: this.docDateRange[1]
            ? this.docDateRange[1].getTime()
            : undefined,
        },
      });
    },

    viewListCVDuocGiao(status) {
      this.$router.push({
        name: "job-index",
        query: {
          taskStatuses: this.convertTaskStatus(status),
          taskStatusFilter: this.convertStatusFilter(status),
          viewType: "receiver",
          fromStartDate: this.docDateRange[0]
            ? this.docDateRange[0].getTime()
            : undefined,
          toStartDate: this.docDateRange[1]
            ? this.docDateRange[1].getTime()
            : undefined,
        },
      });
    },

    viewDetailCVDuocGiao(item) {
      this.$router.push({
        name: "detail-job",
        query: {
          taskStatuses: null,
          taskStatusFilter: null,
          viewType: "receiver",
          fromStartDate: this.docDateRange[0]
            ? this.docDateRange[0].getTime()
            : undefined,
          toStartDate: this.docDateRange[1]
            ? this.docDateRange[1].getTime()
            : undefined,
        },
        params: {
          id: item.id,
        },
      });
    },

    viewDetailCVDaGiao(item) {
      this.$router.push({
        name: "detail-job-assigned",
        query: {
          delegateFilter: "all",
          taskStatuses: null,
          taskStatusFilter: null,
          viewType: "assigner",
          fromStartDate: this.docDateRange[0]
            ? this.docDateRange[0].getTime()
            : undefined,
          toStartDate: this.docDateRange[1]
            ? this.docDateRange[1].getTime()
            : undefined,
        },
        params: {
          id: item.id,
        },
      });
    },

    convertStatusFilter(status) {
      switch (status) {
        case "CHO_PHE_DUYET_DK":
          return "choPheDuyet";
        case "DANG_THUC_HIEN":
          return "dangThucHien";
        case "HOAN_THANH":
          return "hoanThanh";
        case "KET_THUC":
          return "ketThuc";
        case "HUY":
          return "tamDung";
        default:
          return null;
      }
    },

    convertTaskStatus(status) {
      switch (status) {
        case "CHO_PHE_DUYET_DK":
          return 0;
        case "DANG_THUC_HIEN":
          return 1;
        case "HOAN_THANH":
          return 3;
        case "KET_THUC":
          return 4;
        case "HUY":
          return [2, 5, 6];
        default:
          return null;
      }
    },

    filterByDocDateRange() {
      this.getDataDashBoard();
    },

    getDataDashBoard() {
      this.loadData();
      if (this.isVisibleIncommingDoc) {
        this.loadIncomingDocsDashBoard();
        this.loadIncomingChartDashBoard();
      }
      if (this.isVisibleOutgoingDoc) {
        this.loadOutgoingDocsDashBoard();
        this.loadOutgoingChartDashBoard();
      }
      if (this.isVisibleChoBanHanh) {
        this.loadVanBanChoBanHanh();
      }
      if (this.isVisibleChoTiepNhan) {
        this.loadVanBanChoTiepNhan();
      }
      if (this.isVisibleCongViec) {
        this.loadDataCVDaGiao();
        this.loadCVDaGiaoChartDashBoard();
        this.loadCVDuocGiaoChartDashBoard();
        this.loadDataCVDuocGiao();
      }
    },
  },
};
</script>

<style src="./dashboard.css" lang="css" scoped></style>



// WEBPACK FOOTER //
// src/views/dashboard/dashboard-index-v2.vue